/** Preference stored in localStorage; resolved theme applied to <html>. */
export const THEME_STORAGE_KEY = 'akara-theme'

/** @returns {'light' | 'dark'} */
export function resolveTheme(preference) {
  return preference === 'dark' ? 'dark' : 'light'
}

/** @returns {'light' | 'dark'} */
export function readStoredPreference() {
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY)
    if (v === 'dark') return 'dark'
    if (v === 'light') return 'light'
    /* legacy: treat "system" and unknown as light */
    if (v === 'system') return 'light'
  } catch {
    /* ignore */
  }
  return 'light'
}

export function applyThemeToDocument(theme) {
  document.documentElement.setAttribute('data-theme', theme)
  document.documentElement.classList.toggle('dark', theme === 'dark')
  document.documentElement.style.colorScheme = theme === 'dark' ? 'dark' : 'light'
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) {
    meta.setAttribute('content', theme === 'dark' ? '#1e3330' : '#4fa89c')
  }
}
